module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am384-fc35b8e067aadf93a7dd75e741f02440.jpg";